export function directionManagerService(http) {
    const serviceName = "DirectionManager";

    return {
        getStandardActivites:(userId,roleMembers,pageNumber,pageSize,sortBy,filters)=>{
            const newSortBy=(sortBy||[]).map(item=>( {member:item.id,sortDirection:item.desc?"Descending":"Ascending"}))

            const newfilter= Object.keys(filters).map(key => {
                return {
                    member:key,
                    operator:filters[key].operator,
                    value: filters[key].columnType=="number"?Number(filters[key].value):filters[key].value
                };
              });
           
            const filter= newfilter.length>0 
                ?{
                    logic:"And",
                    filters:newfilter
                }
                :null;

            const data = {
                    user:{
                        id:userId
                    },
                    roleMembers,
                    dataAttribute:{
                        page:pageNumber,
                        pageSize,
                        sorts:newSortBy,
                        filter:filter
                    }
            };
            return http.post(serviceName + "/GetStandardActivites",data);
        },
        updateStandardActivities:(standardActivities)=>{

            const data={
                standardActivities
            }

            return http.post(serviceName + "/UpdateStandardActivites",data);
        },
        getDetermineTask:(userId,roleMembers,pageNumber,pageSize,sortBy,filters)=>{
            const newSortBy=(sortBy||[]).map(item=>( {member:item.id,sortDirection:item.desc?"Descending":"Ascending"}))

            const newfilter= Object.keys(filters).map(key => {
                return {
                    member:key,
                    operator:filters[key].operator,
                    value: filters[key].columnType=="number"?Number(filters[key].value):filters[key].value
                };
              });
           
            const filter= newfilter.length>0 
                ?{
                    logic:"And",
                    filters:newfilter
                }
                :null;

            const data = {
                    user:{
                        id:userId
                    },
                    roleMembers,
                    dataAttribute:{
                        page:pageNumber,
                        pageSize,
                        sorts:newSortBy,
                        filter:filter
                    }
            };
            return http.post(serviceName + "/GetDeterminedTask",data);           
        },
        getDisciplineEmployees:(user,roleMembers)=>{
            const data={
                user,
                roleMembers
            };
            return http.post(serviceName + "/GetDisciplineEmployees",data);
        },
        updateEmployeeSubSection:(userId,subsectionCode)=>{
            const data={
                userId,
                subsectionCode
            };
            return http.post(serviceName + "/UpdateEmployeeSubSection",data);
        }


    }
}